interface CodeName {
    code?: string
    name?: string
}

interface CodeSymbol {
    code: string
    symbolCode?: string
}

/**
 * Quote currencies used in CMS filter symbols (e.g. "UNIUSDT", "GNOBTC", "DAIUSD")
 */
const FILTER_QUOTE_CURRENCIES = ['USDT', 'USD', 'USDC', 'BTC']

/**
 * check whether a coin belongs to a CMS symbols filter.
 * CMS values can be plain currency codes ("BTC") or trading pairs ("UNIUSDT").
 * With the new rate service the symbols map is not loaded and `symbolCode` is empty,
 * so pairs are also matched by deriving them from the currency code.
 */
export function isCoinInSymbolsFilter(symbols: Set<string>, { code, symbolCode }: CodeSymbol) {
    if (symbolCode && symbols.has(symbolCode)) {
        return true
    }

    const upperCode = code.toUpperCase()

    if (symbols.has(upperCode)) {
        return true
    }

    return FILTER_QUOTE_CURRENCIES.some(
        quote => symbols.has(`${upperCode}${quote}`) || symbols.has(`${quote}${upperCode}`)
    )
}

/**
 * create filter by code or name of entity with input string
 */
export function makeFilterByCodeName(inputValue: string) {
    if (!inputValue) {
        return () => true
    }
    const lowerInputValue = inputValue.toLowerCase()
    return ({ code, name }: CodeName) =>
        code?.toLowerCase().includes(lowerInputValue) || name?.toLowerCase().includes(lowerInputValue)
}
